import { Component, QueryList, ViewChildren } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { DataService } from '../../../services/data/data.service';
import { GraphATService } from '../../../services/riesgo-credito/riesgos/graph/graph-at.service';
import { CommonVariables, FuncionesMes } from '../../funciones/funcionesGenerales';
import { FiltersM, typesApex } from '../../../components/models';
import { companiesRiesgoCredito, companiesRiesgoCreditoAT } from '../../../shared/catalogos';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';
import { messages } from '../../funciones/mensajes';
import { getCategoriasCobertura } from '../catalogoRC';
import { ExcelService } from '../../../services/excel/excel.service';

interface Cobertura {
  __typename?: string;
  estatus: string;
  numero: number;
  saldo: number;
  montoConstituido: number;
}

const ordenarCoberturas = (coberturas: Cobertura[]): Cobertura[] => {

  const normalizar = (texto: string): string => {
    return texto
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  };

  const obtenerOrdenBanda = (estatus: string): number => {
    const texto = normalizar(estatus);
    if (texto === 'al dia') {
      return 0;
    }

    const rango = texto.match(/^(\d+)\s+a\s+(\d+)$/);
    if (rango) {
      return Number(rango[1]);
    }

    const masDe = texto.match(/^mas\s+de\s+(\d+)$/);

    if (masDe) {
      return Number(masDe[1]);
    }
    return Number.MAX_SAFE_INTEGER;
  };

  return [...coberturas].sort(
    (a, b) =>
      obtenerOrdenBanda(a.estatus) -
      obtenerOrdenBanda(b.estatus)
  );
};
@Component({
  selector: 'app-cobertura',
  templateUrl: './cobertura.component.html',
  styleUrl: './cobertura.component.css'
})
export class CoberturaComponent {
  public idPlantilla;
  private idInst;
  private idAdmin: string;
  private numEvaluaciones = 1;
  public Periodos;
  public Filters = FiltersM;
  @ViewChildren(GraficadorComponent)grafCmp!:QueryList<GraficadorComponent>;  
  public color = ['#76C4D5','#008FBE'];
  public color2 = ['#76C4D5','#008FBE'];
  public color3 = ['#2843A0','#15A075','#36CAE8','#78EAD2','#F88476','#E23E6A'];
  public miles = ',';
  public decimal = '.';
  public datos = [];
  public totales: any;
  public montosSinD = [];
  public montosConD = [];
  public estimaciones = [];
  public parEstimaciones;
  public parEstimaciones7;
  public cobertura = [];
  public parCobertura;
  public parCobertura7;
  public afectacion = [];
  public parAfectacion;
  public parAfectacion7;


  private saldosCartera = [0,0,0];
  private montoReq;
  private montoConst;
  private deduccionesPares;
  private garantiaPares;
  private montosSinDPares;
  private montosConDPares;
  private montoRP = [0,0,0];
  /*Titulos y subtitulos*/
  public subTitles = '';
  /*Filtros*/
  public cadenaEvaluacion = [];
  public encPar = '';
  public pares = ['PAR 1','PAR 30','PAR 60','PAR 90'];
  public tablaGraficaIzq = false; //tabla = true; grafica = false
  public tablaGraficaCen = false; //tabla = true; grafica = false
  public tablaGraficaDer = true; //tabla = true; grafica = false
  //grafica
  public tituloModal = '';
  public tipoGraf = typesApex;

  public grafAmpIzq: boolean = false;
  public showEtiIzq: boolean = false;
  public etiquetasIzq = ['PAR 1', 'PAR 30', 'PAR 60', 'PAR 90'];
  public dataIzq = [];
  public tipoIzq = this.tipoGraf.BAR;
  public xAxisLabelIzq: string = 'Cartera';
  public yAxisLabelIzq: string[] = ['%'];
  public changeLabelIzq: boolean = true;

  public grafAmpCen: boolean = false;
  public showEtiCen: boolean = false;
  public etiquetasCen = ['PAR 1', 'PAR 30', 'PAR 60', 'PAR 90'];
  public dataCen = [];
  public tipoCen = this.tipoGraf.LINE;
  public xAxisLabelCen: string = 'Cartera';
  public yAxisLabelCen: string[] = ['%'];
  public changeLabelCen: boolean = true;

  public grafAmpDer: boolean = false;
  public showEtiDer: boolean = false;
  public etiquetasDer = ['PAR 1', 'PAR 30', 'PAR 60', 'PAR 90'];
  public dataDer = [];
  public tipoDer = this.tipoGraf.COMBO;
  public xAxisLabelDer: string = '';
  public yAxisLabelDer: string[] = ['Monto', 'Patrimonio efectivo'];
  public changeLabelDer: boolean = true;

  ngOnInit(){
    this.idInst = Number(this.cookies.get('idInstitucion'));
    this.idAdmin = companiesRiesgoCredito.find(c => c.id == this.idInst).idAdmin;
    var instAT = companiesRiesgoCreditoAT.find(i => i.id == this.idInst);
    if(instAT){
      this.idPlantilla = Number(instAT.idPlantilla);
      this.getEvaluaciones();
      this.encPar = this.pares[0];
    }else{      
      setTimeout(() => {
        var nombre = companiesRiesgoCredito.find(c => Number(c.id) === this.idInst).name;
        messages.infoMessageGraph(nombre + this.translate.instant('swal.instNoInfo'));
      },500)     
    }
  }

  constructor(
    public cookies: CookieService,
    public dataService: DataService,
    private translate: TranslateService,
    private graph: GraphATService,
    private excel: ExcelService
  ){}
 /*Formateo de cantidades recibe el numero a formatear 
  y true para decimales false sin decimales */
  public formatoNum(num, dec){
    if (num !== undefined && num !== ''){
      return CommonVariables.formatearMoneda(num, dec, this.miles, this.decimal);
    }
  }
  /* formateo de datos */
  public escrituraPeriodo(Periodo){
    if(Periodo.split(' ').length === 2){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }else if(Periodo.split(' ').length === 5){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1]+' '+datos[2]+' '+this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }
    return Periodo;
  }
  private async getEvaluaciones(){
    var data = await this.graph.getEvaluaciones(this.idPlantilla);
    const info = CommonVariables.obtenerPeriodos([].concat(data), this.numEvaluaciones);
    this.Periodos = info.periodos;
    for(const an of this.Periodos){
      if(an.anio < 2023){
        an.utilizable = false;
      }
    }
    this.obtenerDataEvaluacion();
  }
  private obtenerDataEvaluacion(){
    this.cadenaEvaluacion = [];
    this.subTitles = "";
    var tot=0;
    for(var i = this.Periodos.length-1; i>=0; i--){
      for(var j = this.Periodos[i].series.length-1; j>=0; j--){
        if(this.Periodos[i].series[j].check || (tot>0 && tot<12)){
          this.cadenaEvaluacion.push({
            evaluacion: this.Periodos[i].series[j].periodo,
            idEvaluacion: this.Periodos[i].series[j].id,
            porcentaje: '%',
            pos: this.Periodos[i].series[j].pos,
            periodo: this.Periodos[i].series[j].an + '-' + FuncionesMes.f_switchmes3(this.Periodos[i].series[j].mes),
            mes: this.Periodos[i].series[j].nmes,
            anio: this.Periodos[i].series[j].an,
          });
          tot++;
        }
      }
    }
    this.subTitles = this.cadenaEvaluacion[0].evaluacion;
    this.idPlantilla === 7 ? this.getDatos() : this.getDatosRiesgos();
  }

  public cambioPeriodo(per){
    for(const an of this.Periodos){
      for(const mes of an.series){
        if(mes.periodo === per.periodo){
          mes.check = true;
        }else{
          mes.check = false;
        }
      }
    }
    this.obtenerDataEvaluacion();
  }

  private async getDatos(){
    const data = await this.graph.getDatos(this.cadenaEvaluacion[0].periodo);
    const categorias = await getCategoriasCobertura.categorias(this.idInst);
    var aux = [], i = 1;
    for(const c of categorias){
      aux.push({
        categoria: c.categoria, //catalogo
        calif: c.calif, //catalogo
        diasMora: c.diasMora,  //catalogo
        numero: data.creditos['CN'+i],
        saldo: data.saldos['CS'+i],
        porcenReq: c.porcenReq,
        garantia: data.garantia_liquida['GL'+i],
        deducciones: data.deducciones_autorizadas['CD'+i],
        montoReq: (data.saldos['CS'+i] - data.deducciones_autorizadas['CD'+i]) * (c.porcenReq/100),//((data.saldos.CS1-data.deducciones_autorizadas.CD1)*0) > 0 ? (data.saldos.CS1-data.deducciones_autorizadas.CD1)*0 : 0,
        montoReqP: ((data.saldos['CS'+i]-data.deducciones_autorizadas['CD'+i])*(c.porcenCobertura/100)) > 0 ? (data.saldos['CS'+i]-data.deducciones_autorizadas['CD'+i])*(c.porcenCobertura/100) : 0,
        montoCons: data.monto_constituido['CM'+i],
        porcenCober: Number(((data.monto_constituido['CM'+i] / data.saldos['CS'+i])*100).toFixed(0)),
        porcenReqP: c.porcenCobertura,        
      });
      i++;
    } 
    this.datos = aux;
    this.getTotales(this.datos);
    this.calculoPares();
  }
  private async getDatosRiesgos(){
    try{
      const categorias = await getCategoriasCobertura.categorias(this.idInst);
      const dataC = await this.graph.getDatosRiesgos(this.idAdmin, {anio: this.cadenaEvaluacion[0].anio, mes: this.cadenaEvaluacion[0].mes})
      const data = ordenarCoberturas(dataC);
      var aux = [], i = 0;
      for(const c of categorias){
        aux.push({
          categoria: c.categoria, //catalogo
          calif: c.calif, //catalogo
          diasMora: c.diasMora,  //catalogo
          numero: data[i].numero,
          saldo: data[i].saldo,
          porcenReq: c.porcenReq,
          garantia: 0,
          deducciones: 0,
          montoReq: data[i].saldo * (c.porcenReq/100),//((data.saldos.CS1-data.deducciones_autorizadas.CD1)*0) > 0 ? (data.saldos.CS1-data.deducciones_autorizadas.CD1)*0 : 0,
          montoReqP: 0,
          montoCons: data[i].montoConstituido,
          porcenCober: Number(((data[i].montoConstituido / data[i].saldo)*100).toFixed(0)),
          porcenReqP: c.porcenCobertura,        
        });
        i++;
      } 
      this.datos = aux;
      this.getTotales(this.datos);
      this.calculoPares();
    }catch(e){
      if(`${e}`.includes('SUPERUSER')){
        location.reload();
      }
      messages.errorMessageGraph(e);
    }
  }
  
  //calculo de la fila de totales de la tabla
  private getTotales(datos){
    var aux = {
      categoria: 'Total', 
      calif: '', 
      diasMora: '',  
      numero: 0,
      saldo: 0,
      garantia: 0,
      deducciones: 0,
      porcenReq: 0,
      montoReq: 0,
      montoCons: 0,
      porcenCober: 0
    }

    for(var i=0; i<datos.length; i++){
      aux.numero += datos[i].numero;
      aux.saldo += datos[i].saldo;
      aux.garantia += datos[i].garantia;
      aux.deducciones += datos[i].deducciones;
      aux.montoReq += datos[i].montoReq;
      aux.montoCons += datos[i].montoCons;
    }
    
    aux.porcenReq = Number((aux.montoReq/aux.saldo*100).toFixed(1)); 
    aux.porcenCober = Number((aux.montoCons/aux.saldo*100).toFixed(1)); 

    this.totales = aux;
  }
  //subcalculos necesario para la obtencion de datos para filtro de pares
  private calculoPares(){
    //resetar los calculos de los pares cuando se cambia de periodo 
    //Formato para pares de coopeduc
    var aux1 = {
      par1: 0,
      par30: 0,
      par60: 0,
      par90: 0
    };
    var aux2 = {
      par1: 0,
      par30: 0,
      par60: 0,
      par90: 0
    };
    var aux3 = {
      par1: 0,
      par30: 0,
      par60: 0,
      par90: 0
    };
    //Formato para pares de coopeduc 
    var aux4 = [];
    var aux5 = [];
    var aux6 = [];

    for (let index = 0; index < 4; index++) {
      aux4.push({
        deduccAut: 0,
        sinDeducc: 0,
        deduccGaran: 0
      });
      aux5.push({
        deduccAut: 0,
        sinDeducc: 0,
        deduccGaran: 0
      });
      aux6.push({
        monto: 0,
        patriEfectivo: 0,
        porcentaje: 0
      });
    }

    this.parEstimaciones = this.idPlantilla !== 7 ? aux1 : aux4;
    this.parCobertura = this.idPlantilla !== 7 ? aux2 : aux5;
    this.parAfectacion = this.idPlantilla !== 7 ? aux3 : aux6;

    /// subcalculos para coopeduc 
    if(this.idPlantilla === 7){
      this.noVisible();
    }

    this.montoReq = [0,0,0,0];
    this.montoConst = [0,0,0,0];
    this.saldosCartera = [0,0,0,0];

    //subcalulos de saldos, garantia, deducciones por 1 30 60 90
    for(let i = 1; i < this.datos.length; i++){
      if(i >= 1){
        //1
        this.montoReq[0] += this.datos[i].montoReq;
        this.montoConst[0] += this.datos[i].montoCons;
        this.saldosCartera[0] += this.datos[i].saldo;
      }
      if(i >= 2){
        //30
        this.montoReq[1] += this.datos[i].montoReq;
        this.montoConst[1] += this.datos[i].montoCons;
        this.saldosCartera[1] += this.datos[i].saldo;
      }
      if(i >= 3){
        //60
        this.montoReq[2] += this.datos[i].montoReq;
        this.montoConst[2] += this.datos[i].montoCons;
        this.saldosCartera[2] += this.datos[i].saldo;
      }
      if(i >= 4){
        //90
        this.montoReq[3] += this.datos[i].montoReq;
        this.montoConst[3] += this.datos[i].montoCons;
        this.saldosCartera[3] += this.datos[i].saldo;
      }
    }
    // subcalculos para coopeduc 
    if(this.idPlantilla === 7){ 
      this.deduccionesPares = [0,0,0,0]
      this.montoRP = [0,0,0,0];
      this.garantiaPares = [0,0,0,0]
      this.montosSinDPares = [0,0,0,0]
      this.montosConDPares = [0,0,0,0]
      for(let i = 1; i < this.datos.length; i++){
        if(i >= 1){
          //1
          this.garantiaPares[0] += this.datos[i].garantia;
          this.deduccionesPares[0] += this.datos[i].deducciones;
          this.montosSinDPares[0] += this.montosSinD[i];
          this.montosConDPares[0] += this.montosConD[i];
          this.montoRP[0] += this.datos[i].montoReqP;
        }
        if(i >= 2){
          //30
          this.garantiaPares[1] += this.datos[i].garantia;
          this.deduccionesPares[1] += this.datos[i].deducciones;
          this.montosSinDPares[1] += this.montosSinD[i];
          this.montosConDPares[1] += this.montosConD[i];
          this.montoRP[1] += this.datos[i].montoReqP;
        }
        if(i >= 3){
          //60
          this.garantiaPares[2] += this.datos[i].garantia;
          this.deduccionesPares[2] += this.datos[i].deducciones;
          this.montosSinDPares[2] += this.montosSinD[i];
          this.montosConDPares[2] += this.montosConD[i];
          this.montoRP[2] += this.datos[i].montoReqP;
        }
        if(i >= 4){
          //90
          this.garantiaPares[3] += this.datos[i].garantia;
          this.deduccionesPares[3] += this.datos[i].deducciones;
          this.montosSinDPares[3] += this.montosSinD[i];
          this.montosConDPares[3] += this.montosConD[i];
          this.montoRP[3] += this.datos[i].montoReqP;
        }
      }
    }
    
    switch(this.idPlantilla){
      case 12: 
        this.getParesSuficiencia();
        this.getParesCobertura();
        this.getParesAfectacion();
        break;
      case 7: 
        this.getParesSuficiencia7();
        this.getParesCobertura7();
        this.getParesAfectacion7();
        break;
    }
    
  }
   //subcalculos informacion no visible 
  private noVisible(){
    var aux1 = [];
    var aux2 = [];

    for(let i = 0; i < this.datos.length; i++){
      aux1.push(Number((this.datos[i].saldo * (this.datos[i].porcenReqP/100)).toFixed(0)));
      aux2.push(Number(((this.datos[i].saldo - this.datos[i].garantia)*(this.datos[i].porcenReqP/100)).toFixed(0)));
    }

    this.montosSinD = aux1;
    this.montosConD = aux2;
  }

  //calculo de datos para lo pares de suficiencia
  private getParesSuficiencia(){
    var cant = [];
    this.dataIzq = [], this.estimaciones = [];
    this.parEstimaciones.par1 = Number(((this.montoConst[0] / this.montoReq[0])*100).toFixed(2));
    this.parEstimaciones.par30 = Number(((this.montoConst[1] / this.montoReq[1])*100).toFixed(2));
    this.parEstimaciones.par60 = Number(((this.montoConst[2] / this.montoReq[2])*100).toFixed(2));
    this.parEstimaciones.par90 = Number(((this.montoConst[3] / this.montoReq[3])*100).toFixed(2));
    cant.push(this.parEstimaciones.par1);
    cant.push(this.parEstimaciones.par30);
    cant.push(this.parEstimaciones.par60);
    cant.push(this.parEstimaciones.par90);
    this.dataIzq.push({name: '', data:cant});
    for(let i = 0; i < cant.length; i++){
      this.estimaciones.push({
        cantidad: cant[i],
        descripcion: this.etiquetasIzq[i]
      })
    }
  }
  private getParesSuficiencia7(){
    for(let i = 0; i < 4; i++){
      this.parEstimaciones[i].deduccAut = Number(((this.totales.montoCons / this.montoRP[i])*100).toFixed(1));
      this.parEstimaciones[i].sinDeducc = Number(((this.totales.montoCons / this.montosSinDPares[i])*100).toFixed(1));
      this.parEstimaciones[i].deduccGaran = Number(((this.totales.montoCons / this.montosConDPares[i])*100).toFixed(1));
    }
    this.getSuficiencia();
  }
  //calculo de datos para lo pares de suficiencia
  private getParesCobertura(){
    this.parCobertura.par1 = Number(((this.totales.montoCons / this.saldosCartera[0])*100).toFixed(2));
    this.parCobertura.par30 = Number(((this.totales.montoCons / this.saldosCartera[1])*100).toFixed(2));
    this.parCobertura.par60 = Number(((this.totales.montoCons / this.saldosCartera[2])*100).toFixed(2));
    this.parCobertura.par90 = Number(((this.totales.montoCons / this.saldosCartera[3])*100).toFixed(2));
    var cant = [];
    this.dataCen = [], this.cobertura = [];
    cant.push(this.parCobertura.par1);
    cant.push(this.parCobertura.par30);
    cant.push(this.parCobertura.par60);
    cant.push(this.parCobertura.par90);
    this.dataCen.push({name: '', data:cant});
    for(let i = 0; i < cant.length; i++){
      this.cobertura.push({
        cantidad: cant[i],
        descripcion: this.etiquetasCen[i]
      })
    }
  }
  public getParesCobertura7(){
    for(let i = 0; i < 4; i++){
      this.parCobertura[i].deduccAut =  Number((this.totales.montoCons / (this.saldosCartera[i] - this.deduccionesPares[i]) * 100));
      this.parCobertura[i].sinDeducc = Number((this.totales.montoCons / this.saldosCartera[i] * 100).toFixed(1));
      this.parCobertura[i].deduccGaran =  Number((this.totales.montoCons / (this.saldosCartera[i] - this.garantiaPares[i]) * 100).toFixed(1));
    }
  }
  //calculo de datos para lo pares de suficiencia
  private async getParesAfectacion(){
    //TODO cuidar que coincida esta vt con el catalogo de institucion
    var vt = companiesRiesgoCreditoAT.find(i => i.id == this.idInst).varPar;
    const data = await this.graph.getDetalleVarTemporales(this.cadenaEvaluacion[0].idEvaluacion, vt);
    var pat = data, p = [1,30,60,90];
    this.afectacion = [{descripcion: 'Monto', pares: []},{descripcion: 'Patrimonio efectivo', pares: []},{descripcion: '% sobre patrimonio efectivo', pares: []}]
    for(let i = 0; i < 4; i++){
      var pc = this.parCobertura['par'+p[i]]/100
      if( pc <= 1){
        this.afectacion[0].pares.push( (1-pc) * this.saldosCartera[i] );
        this.afectacion[1].pares.push( pat );
        this.afectacion[2].pares.push( Number((this.afectacion[0].pares[i] / this.afectacion[1].pares[i]).toFixed(2)) );
        this.parAfectacion['par'+p[i]] = Number((this.afectacion[2].pares[i]*100).toFixed(2));
      }else{
        this.afectacion[0].pares.push( 0 );
        this.afectacion[1].pares.push( pat );
        this.afectacion[2].pares.push( Number((this.afectacion[0].pares[i] / this.afectacion[1].pares[i]).toFixed(2)) );
        this.parAfectacion['par'+p[i]] = Number((this.afectacion[2].pares[i]*100).toFixed(2));
      }
    }
    this.dataDer = [
      {name: this.afectacion[0].descripcion, data: this.afectacion[0].pares},
      {name: this.afectacion[1].descripcion, data: this.afectacion[1].pares},
    ]
  }
  private async getParesAfectacion7(){
    var vt = companiesRiesgoCreditoAT.find(i => i.id == this.idInst).varPar;
    const data = await this.graph.getDetalleVarTemporales(this.cadenaEvaluacion[0].idEvaluacion, vt);
    var pat = data;
    for(let i = 0; i < 3; i++){
      if(this.parCobertura[i].deduccAut/100 > 1){
        this.parAfectacion[i].monto = 0;
        this.parAfectacion[i].patriEfectivo = pat; //catalogo
        this.parAfectacion[i].porcentaje =  Number((this.parAfectacion[i].monto / this.parAfectacion[i].patriEfectivo * 100).toFixed(2));
      }else{
        this.parAfectacion[i].monto =  (1-((this.parCobertura[i].deduccAut/100)))*this.saldosCartera[i];
        this.parAfectacion[i].patriEfectivo = pat; //catalogo
        this.parAfectacion[i].porcentaje =  Number((this.parAfectacion[i].monto / this.parAfectacion[i].patriEfectivo * 100).toFixed(2));
      }
    }
    this.getCobertura();
    this.getAfectacion();    
  }
  //muestra el par seleccionado de suficiencia
  public getSuficiencia(){
    var datosAux = [];
    if(this.encPar == this.pares[0]){
      datosAux.push(this.parEstimaciones[0].deduccAut);
      datosAux.push(this.parEstimaciones[0].sinDeducc);
      datosAux.push(this.parEstimaciones[0].deduccGaran);
    }else if(this.encPar == this.pares[1]){
      datosAux.push(this.parEstimaciones[1].deduccAut);
      datosAux.push(this.parEstimaciones[1].sinDeducc);
      datosAux.push(this.parEstimaciones[1].deduccGaran);
    }else if(this.encPar == this.pares[2]){
      datosAux.push(this.parEstimaciones[2].deduccAut);
      datosAux.push(this.parEstimaciones[2].sinDeducc);
      datosAux.push(this.parEstimaciones[2].deduccGaran);
    }else{
      datosAux.push(this.parEstimaciones[3].deduccAut);
      datosAux.push(this.parEstimaciones[3].sinDeducc);
      datosAux.push(this.parEstimaciones[3].deduccGaran);
    }
    var aux = [];
    aux.push({
      descripcion: "Con deducciones autorizadas(más garantía líquida)",
      cantidad: datosAux[0]
    });
    aux.push({
      descripcion: "Sin deducciones autorizadas",
      cantidad: datosAux[1]
    });
    aux.push({
      descripcion: "Con deducciones de garantía líquida",
      cantidad: datosAux[2]
    });

    this.estimaciones = aux;
    var cantidades = [];
    var etiquetas = [];
    var data =[];
    for(const i of this.estimaciones){
      cantidades.push(i.cantidad == null ? 0: i.cantidad);
      etiquetas.push(i.descripcion);
    }
    data.push({
      name: '',
      data: cantidades
    })
    this.dataIzq = data;
    this.etiquetasIzq = etiquetas;  
  }
  //muestra el par seleccionado de cobertura (inferior central)
  private getCobertura(){
    var datosAux = [];
    if(this.encPar == this.pares[0]){
      datosAux.push(this.parCobertura[0].deduccAut);
      datosAux.push(this.parCobertura[0].sinDeducc);
      datosAux.push(this.parCobertura[0].deduccGaran);
    }else if(this.encPar == this.pares[1]){
      datosAux.push(this.parCobertura[1].deduccAut);
      datosAux.push(this.parCobertura[1].sinDeducc);
      datosAux.push(this.parCobertura[1].deduccGaran);
    }else if(this.encPar == this.pares[2]){
      datosAux.push(this.parCobertura[2].deduccAut);
      datosAux.push(this.parCobertura[2].sinDeducc);
      datosAux.push(this.parCobertura[2].deduccGaran);
    }else{
      datosAux.push(this.parCobertura[3].deduccAut);
      datosAux.push(this.parCobertura[3].sinDeducc);
      datosAux.push(this.parCobertura[3].deduccGaran);
    }

    var aux = [];
    aux.push({
      descripcion: "Con deducciones autorizadas(más garantía líquida)",
      cantidad: Number((datosAux[0]).toFixed(1))
    });
    aux.push({
      descripcion: "Sin deducciones autorizadas",
      cantidad: Number((datosAux[1]).toFixed(1))
    });
    aux.push({
      descripcion: "Con deducciones de garantía líquida",
      cantidad: Number((datosAux[2]).toFixed(1))
    });

    this.cobertura = aux;
    var cantidades = [];
    var etiquetas = [];
    var data =[];
    for(const i of this.cobertura){
      cantidades.push(i.cantidad == null ? 0: i.cantidad);
      etiquetas.push(i.descripcion);
    }

    data.push({
      name: '',
      data: cantidades
    })
    this.dataCen = data;
    this.etiquetasCen = etiquetas;
  }
   //muestra el par seleccionado de afectacion (inferior derecha)
  private getAfectacion(){
    var datosAux = [];
    if(this.encPar == this.pares[0]){
      datosAux.push(this.parAfectacion[0].monto);
      datosAux.push(this.parAfectacion[0].patriEfectivo);
      datosAux.push(this.parAfectacion[0].porcentaje);
    }else if(this.encPar == this.pares[1]){
      datosAux.push(this.parAfectacion[1].monto);
      datosAux.push(this.parAfectacion[1].patriEfectivo);
      datosAux.push(this.parAfectacion[1].porcentaje);
    }else{
      datosAux.push(this.parAfectacion[2].monto);
      datosAux.push(this.parAfectacion[2].patriEfectivo);
      datosAux.push(this.parAfectacion[2].porcentaje);
    }

    var aux = [];
    
    aux.push({
      descripcion: "Monto",
      cantidad: Number((datosAux[0]).toFixed(0))
    });
    aux.push({
      descripcion: "Patrimonio efectivo",
      cantidad: Number((datosAux[1]).toFixed(0))
    });
    aux.push({
      descripcion: "Porcentaje sobre patrimonio efectivo",
      cantidad: Number((datosAux[2]).toFixed(2))
    });

    this.afectacion = aux;
    var cantidades = [];
    var etiquetas = [];
    var data =[];
    var api;

    if(this.tipoCen != "treemap"){
      for(let i = this.afectacion.length-1; i > 0 ; i--){
        data.push({
          name: this.afectacion[i-1].descripcion,
          data: [this.afectacion[i-1].cantidad == null ? 0: this.afectacion[i-1].cantidad]
        })
        //cantidades.push(this.afectacion[i].cantidad == null ? 0: this.afectacion[i].cantidad);
      }
      etiquetas.push(this.escrituraPeriodo(this.subTitles));
      api = true;
    }else{
      for(let i = this.afectacion.length-1; i > 0 ; i--){
        cantidades.push({
          x: this.afectacion[i-1].descripcion,
          y: this.afectacion[i-1].cantidad == null ? 0: this.afectacion[i-1].cantidad
        });
        etiquetas.push(this.afectacion[i-1].descripcion);
      }
      data.push({
        data: cantidades
      })
      api = false;
    }
    this.dataDer = data;
    this.etiquetasDer = etiquetas;
  }
   //ampliar la grafica 
  public ampliarGraf(zona){
    var aux : any = {};
    if(zona == 'izq'){
      this.grafAmpIzq = true;
      this.tituloModal = 'Izquierdo';
    }
    if(zona == 'cen'){
      this.grafAmpCen = true;
      this.tituloModal = 'Centro';
    }
    if(zona == 'der'){
      this.grafAmpDer = true;
      this.tituloModal = 'Derecho';
    }
    document.getElementById("ampliar")!.style.display = "block";
  }
  //Cerrar modal ampliar grafica
  public closeModal(){
    this.grafAmpIzq = false;
    this.grafAmpCen = false;
    this.grafAmpDer = false;
    document.getElementById("ampliar")!.style.display = "none";
  }

  //detecta el click fuera del modal y cierra 
  public clickFuera(event){
    if (event.target === document.getElementById("ampliar")) {
      this.closeModal();
    }
  }
  //cambiar el filtro de par 
  public cambioPar(nPar){
    this.encPar = this.pares[nPar];
    this.getSuficiencia();
    this.getCobertura();
    this.getAfectacion();
  }
  //intercambio entre tabla grafica zona inferior izquierda
  public cambioContenedorEstimaciones(band, tipo){
    if(band){
      this.tablaGraficaIzq = true;
      this.tipoIzq = undefined;
    }else{
      this.tablaGraficaIzq = false;
      this.tipoIzq = tipo;
    }
  }
  //intercambio entre tabla grafica zona inferior centro
  public cambioContenedorCobertura(band, tipo){
    if(band){
      this.tablaGraficaCen = true;
      this.tipoCen = undefined;
    }else{
      this.tablaGraficaCen = false;
      this.tipoCen = tipo;
    }
  }
  //intercambio entre tabla grafica zona inferior derecha
  public cambioContenedorAfectacion(band, tipo){
    this.tipoDer = tipo;
    if(band){
      this.tipoDer = undefined
      this.tablaGraficaDer = true;
      // this.getAfectacion();      
    }else{
      this.tablaGraficaDer = false;
      this.tipoDer = tipo;
      // this.getAfectacion();
    }
  }
  //metodo para exportar tabla a formato excel
  public exportarTabla(){
    var encabezado1 = [], encabezado2 = [], datos = [], totales = [];

    encabezado1.push("");
    encabezado1.push("");
    encabezado1.push("");
    encabezado1.push(this.translate.instant('credito.estimaciones.titulo1Tabla'));
    encabezado1.push("");
    encabezado1.push(this.translate.instant('credito.estimaciones.titulo2Tabla'));
    encabezado1.push("");
    encabezado1.push("");
    encabezado1.push("");

    for (let index = 1; index < 10; index++) {
      encabezado2.push(this.translate.instant('credito.estimaciones.encabezado' + index))
    }

    for(const i of this.datos){
      var aux = [];
      aux.push(i.categoria);
      aux.push(i.calif);
      aux.push(i.diasMora);
      aux.push(i.numero);
      aux.push(i.saldo);
      // aux.push(i.garantia);
      // aux.push(i.deducciones);
      aux.push(i.porcenReq/100);
      aux.push(i.montoReq);
      aux.push(i.montoCons);
      aux.push(i.porcenCober/100);

      datos.push(aux);
    }

    totales.push("Total");
    totales.push("");
    totales.push("");
    totales.push(this.totales.numero);
    totales.push(this.totales.saldo);
    // totales.push(this.totales.garantia);
    // totales.push(this.totales.deducciones);
    totales.push(this.totales.porcenReq/100);
    totales.push(this.totales.montoReq);
    totales.push(this.totales.montoCons);
    totales.push(this.totales.porcenReq/100);

    let tituloHoja = this.translate.instant('credito.estimaciones.tituloTabla') + " | " + this.escrituraPeriodo(this.subTitles);

    this.excel.excelCreditoEstimaciones(tituloHoja,encabezado1,encabezado2,datos,totales,this.translate.instant('credito.estimaciones.tituloTabla') + ' ' + this.escrituraPeriodo(this.subTitles));
  }

  //metodo exportar graficas en imagenes
  public exportarGrafica(zon, nombre){
    var nombreGraf = {titulo: '', subtitulo:'', nombreArch: ''};
    nombreGraf.titulo = this.translate.instant(nombre);
    nombreGraf.nombreArch = this.translate.instant(nombre);
    nombreGraf.subtitulo = this.escrituraPeriodo(this.subTitles);
    const comp = this.grafCmp.find(g => g.zona === zon);
    comp.exportImg(zon,nombreGraf);
  }

}
